export interface User {
  uid: string;
  email: string | null;
  displayName: string | null;
  photoURL: string | null;
  emailVerified: boolean;
  providerId?: string;
  createdAt?: string;
  lastLoginAt?: string;
  layout?: LayoutConfig;

  id: string;
  name: string;
  phoneNo?: string;
  role: UserRole;
  permissions?: string;
  partner_id?: string;
  partner_array?: string[];
  isJustBaatAdmin?: boolean;
  isNewUser?: boolean;
  thirdPartyCreds?: Record<string, unknown>;
  config?: {
    partner_id: string;
    appId: string;
    secret: string;
    showEditor: boolean;
    websites: string[];
    adApps?: any[];
    isLiveReportingEnable?: boolean;
    transitionHardCoded?: any;
    reportingFilters?: Record<string, any>;
    features?: any[];
  };
  doohConfig?: {
    logo?: string;
    videoCreativeLimit?: number;
    imageCreativeLimit?: number;
    campaignDashboard?: boolean;
    bulkUploadLimitMb?: number;
  };
}

export type FirebaseIdentity = Omit<User, 'role'>;

export interface UserProfile {
  uid: string;
  firstName?: string;
  lastName?: string;
  displayName?: string;
  bio?: string;
  avatarUrl?: string;
  email?: string;
  phone?: string;
  role?: UserRole;
  permissions?: Permission[];
  preferences?: UserPreferences;
  createdAt: string;
  updatedAt: string;
}

export interface UserPreferences {
  theme: 'light' | 'dark';
  language: string;
  notifications: {
    email: boolean;
    push: boolean;
    sms: boolean;
  };
  timezone?: string;
}

export type UserRole =
  | 'user'
  | 'ADMIN'
  | 'DOOH_ADMIN'
  | 'DOOH_ADVERTISER'
  | 'DOOH_OPS'
  | 'JB_SST_USER'
  | 'JB_TEST'
  | 'ADS_ADMIN'
  | 'ADS_EDITOR'
  | 'SUPER_ADMIN'
  | 'DOOH_SUPER_ADMIN';

export const DOOH_ROLES = [
  'DOOH_ADMIN',
  'DOOH_ADVERTISER',
  'DOOH_OPS',
  'DOOH_SUPER_ADMIN',
] as const;

export interface Permission {
  id: string;
  name: string;
  description?: string;
  resource: string;
  action: string;
}

export interface AuthState {
  user: User | null;
  profile: UserProfile | null;
  isLoading: boolean;
  isAuthenticated: boolean;
  error: string | null;
  skipLayoutRefetch: boolean;
}

interface ComponentConfig {
  id: string;
  props?: Record<string, any>;
}

interface WidgetItem {
  id: string;
  props?: Record<string, any>;
}

interface WidgetGroup {
  order: number;
  widgets: WidgetItem[];
}

export interface PageConfig {
  title: string;
  components?: ComponentConfig[];
  widgets?: WidgetGroup[];
}

interface SidebarItem {
  title: string;
  icon?: string;
  pageid?: string;
  subMenu?: SidebarItem[];
}

export interface LayoutConfig {
  id?: string;
  partner_id?: string;
  routes?: string[];
  sidebar?: SidebarItem[];
  [pageKey: string]: any;
}
